import type { NotificacaoItem } from '@/types/notificationBell/types';

/**
 * Para onde o sino leva quando o item não tem um `onItemClick` próprio. O `cta` vem do core
 * (`relatorio_lex.concluido`), mas só vira navegação se for caminho relativo de uma tela que
 * sabe abrir o item por query: a allowlist é a defesa contra open redirect (Q13, A9).
 */
const PREFIXOS_DE_DESTINO = ['/negociacoes/relatorios?', '/notificacoes/relatorios?'] as const;

export const destinoDoItemDoSino = ({ cta }: Pick<NotificacaoItem, 'cta'>): string | null =>
  cta && PREFIXOS_DE_DESTINO.some((prefixo) => cta.startsWith(prefixo)) ? cta : null;
